<template>
  <main
    class="layout__body no-padding"
    :class="{ 'prevent-scrolling': isSearchOpened }"
  >
    <div v-if="wide_subcategories">
      <ListOfProducts
        ref="listOfProducts"
        :categoryId="subcategoryId"
        :subcategory="true"
        @disableScroll="disableScroll"
        @enableScroll="enableScroll"
      />
    </div>
    <div v-else>
      <header class="market-fixed-header" ref="header">
        <div class="market-header-card">
          <div class="market-header-title">
            <div class="market-header-with-back-btn">
              <v-skeleton-loader
                v-if="!subcategory"
                type="text"
                class="skeleton-header"
                width="150"
              ></v-skeleton-loader>
              <span v-else class="market-header-category">
                {{ subcategory.name }}
              </span>
            </div>
            <LimitTag />
          </div>
          <MarketSearch
            @disableScroll="disableScroll"
            @enableScroll="enableScroll"
          />
        </div>
      </header>
      <div class="market-container" :style="{ marginTop: headerHeight + 8 + 'px' }">
        <v-skeleton-loader
          v-if="!subcategoryById"
          type="list-item@10"
          class="skeleton-category"
        ></v-skeleton-loader>
        <div v-else>
          <div @click="allProductsClicked">
            <div class="market-category-item">
              <div class="market-category-left">
                <span class="market-category-text">Все товары</span>
              </div>
              <div v-if="limitType !== 'office_supplies'" class="market-category-right">
                <span class="market-category-products-count">
                  {{ subcategory.products_count }}
                </span>
                <img src="@/assets/marketplace/chevron_right.svg" alt="right" />
              </div>
            </div>
            <hr v-if="subcategoryById.length" class="market-divider" />
          </div>
          <router-link
            v-for="(subcategory, index) in subcategoryById"
            :key="subcategory.id"
            :to="(subcategory.numchild > 0) ?
              { name: 'Sub-subcategory', params: { sub_subcategoryId: subcategory.id } } :
              { name: 'List of products', params: { categoryId: subcategory.id, level: 1 } }
            "
          >
            <div class="market-category-item">
              <div class="market-category-left">
                <span class="market-category-text">{{ subcategory.name }}</span>
              </div>
              <div v-if="limitType !== 'office_supplies'" class="market-category-right">
                <span class="market-category-products-count">
                  {{ subcategory.products_count }}
                </span>
                <img src="@/assets/marketplace/chevron_right.svg" alt="right" />
              </div>
            </div>
            <hr v-if="index !== subcategoryById.length - 1" class="market-divider" />
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ListOfProducts from "@/views/marketplace/list_of_products.vue";
import MarketSearch from "@/components/marketplace/market_search.vue";
import { mapState, mapActions } from "vuex";
import { backNavigateQueue } from "@/helpers/app.js";
import { amplitudeMarketplace } from "@/helpers/amplitudeMarket";
import LimitTag from "@/components/marketplace/LimitTag.vue"

export default {
  name: "subcategory",
  components: {
    LimitTag,
    ListOfProducts,
    MarketSearch,
  },
  props: {
    subcategoryId: [Number, String],
  },
  data: () => ({
    headerHeight: undefined,
    isSearchOpened: false,
  }),
  computed: {
    ...mapState("marketplace", [
      "limit",
      "limitType",
      "wide_subcategories",
      "categories",
      "subcategoryById"
    ]),
    subcategory () {
      return this.categories.find(subcategory => {
        return subcategory.id == this.subcategoryId;
      })
    },
  },
  async created() {
    await this.getSubcategoryById(this.subcategoryId);
    if (this.wide_subcategories) this.$refs.listOfProducts.getHeaderHeight();
    amplitudeMarketplace({
      event_type: "Инструменты - Переход в категорию",
      extra_info: {
        level: 1,
        title: this.subcategory.name
      },
      project_name: "Marketplace"
    });
  },
  mounted() {
    backNavigateQueue.set(this.backToMainMarket);
    this.getHeaderHeight();
  },
  methods: {
    ...mapActions("marketplace", [
      "set_wide_subcategories",
      "reset_wide_subcategories",
      "getSubcategoryById",
      "clearSubcategory",
      "clearProductsPaginationInfo",
      "clearListOfProducts",
      "clearBrandsByCategory",
      "clearQueryParams",
      "clearFiltersPaginationInfo",
      "clearProductsByFilter",
    ]),
    getHeaderHeight() {
      let headerRef = this.$refs.header;
      this.headerHeight = headerRef ? headerRef.clientHeight : 0;
      this.$forceUpdate();
    },
    scrollToTop() {
      window.scrollTo({ top: 0 });
    },
    backToMainMarket() {
      this.$router.go(-1);
    },
    disableScroll() {
      this.isSearchOpened = true;
    },
    enableScroll() {
      this.isSearchOpened = false;
    },
    allProductsClicked() {
      this.set_wide_subcategories();
      amplitudeMarketplace({
        event_type: "Инструменты - Переход во Все товары",
        extra_info: null,
        project_name: "Marketplace"
      });
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (
      to.name !== 'Sub-subcategory' &&
      to.name !== 'List of products' &&
      to.name !== 'ProductById'
    ) {
      if (this.wide_subcategories && !to.params.isFromFooter) {
        await this.reset_wide_subcategories();
        this.clearProductsPaginationInfo();
        this.clearListOfProducts();
        this.clearBrandsByCategory();
        this.clearQueryParams();
        this.clearFiltersPaginationInfo();
        this.clearProductsByFilter();
        this.getHeaderHeight();
        this.scrollToTop();
        next(false);
      } else {
        if (to.params.isFromFooter) await this.reset_wide_subcategories();
        this.clearSubcategory();
        this.clearProductsPaginationInfo();
        this.clearListOfProducts();
        this.clearBrandsByCategory();
        this.clearQueryParams();
        this.clearFiltersPaginationInfo();
        this.clearProductsByFilter();
        next();
      }
    } else if (
      to.name === 'Sub-subcategory' ||
      to.name === 'List of products'
    ) {
      this.clearProductsPaginationInfo();
      this.clearListOfProducts();
      this.clearBrandsByCategory();
      this.clearQueryParams();
      this.clearFiltersPaginationInfo();
      this.clearProductsByFilter();
      next();
    } else next();
  },
};
</script>

<style lang="scss" scoped>
.market-header-card, .market-container {
  box-shadow: 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
